import React from 'react';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import styled from 'styled-components';

const Option = styled.div`
  height: 50px;
  border: solid 1px #00518E;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #00518E;
  font-weight: bold;
  font-size: 1rem;
  background-color: #E1EFFF;
  margin-bottom: 5px;
`;

const TailOption = (props) => {
  const { option, selected } = props;
  return (
    <Option
      onClick={() => {
        selected(option)
      }}
    >
      {option.tailNumber}
    </Option>
  )
}

export default TailOption;
